export const MAX_LEVEL = 3

export const RES_CODE_SUCCESS = 0

export const CSRF_KEY = 'access_token'

/*
 * @Author: lhx
 * @Date: 2024-07-17 10:12:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-30 10:11:39
 * @FilePath: \admin-web-xingya\app-config.js
 * @Description:
 */
export const appList = [
  { label: '星芽短剧', value: 'xydj' },
  { label: '冬橙短剧', value: 'dcdj' },
  { label: '东梨短剧', value: 'dldj' },
  { label: '独加短剧', value: 'djdj' },
  { label: '星芽会员VIP', value: 'xvdj' }
]
export default {
  test: {
    xydj: {
      appName: '星芽短剧',
      appNameEnv: '星芽短剧测试',
      type: 'xydj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'TESTXYDJ',
      homeDomin: 'http://testvue.whjzjx.cn'
    },
    dcdj: {
      appName: '冬橙短剧',
      appNameEnv: '冬橙短剧测试',
      type: 'dcdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'TESTDCDJ',
      homeDomin: 'http://testdcvue.xingya.com.cn'
    },
    dldj: {
      appName: '东梨短剧',
      appNameEnv: '东梨短剧测试',
      type: 'dldj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'TESTDL',
      homeDomin: 'http://testdlvue.xingya.com.cn'
    },
    djdj: {
      appName: '独加短剧',
      appNameEnv: '独加短剧测试',
      type: 'djdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'TESTDJDJ',
      homeDomin: 'http://testdjvue.xingya.com.cn'
    },
    xvdj: {
      appName: '星芽会员VIP',
      appNameEnv: '星芽会员VIP测试',
      type: 'xvdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'TESTXVDJ',
      homeDomin: 'http://testxyvipvue.xingya.com.cn'
    }
  },
  prod: {
    xydj: {
      appName: '星芽短剧',
      appNameEnv: '星芽短剧',
      type: 'xydj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'XYDJ',
      homeDomin: 'https://vue.whjzjx.cn'
    },
    dcdj: {
      appName: '冬橙短剧',
      appNameEnv: '冬橙短剧',
      type: 'dcdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'DCDJ',
      homeDomin: 'http://dcvue.xingya.com.cn'
    },
    dldj: {
      appName: '东梨短剧',
      appNameEnv: '东梨短剧',
      type: 'dldj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'DL',
      homeDomin: 'http://dlvue.xingya.com.cn'
    },
    djdj: {
      appName: '独加短剧',
      appNameEnv: '独加短剧',
      type: 'djdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'DJDJ',
      homeDomin: 'http://djvue.xingya.com.cn'
    },
    xvdj: {
      appName: '星芽会员VIP',
      appNameEnv: '星芽会员VIP',
      type: 'xvdj',
      serviceMainKey: 'FreeTheaterAppAdmin',
      serviceHeaderPrefix: 'XVDJ',
      homeDomin: 'http://xyvipvue.xingya.com.cn'
    }
  }
}

export const adTypeOptions = [
  {
    value: 1,
    label: '信息流'
  },
  {
    value: 2,
    label: '插屏/新插屏'
  },
  {
    value: 3,
    label: '激励视频'
  },
  {
    value: 4,
    label: 'draw信息流/视频广告'
  },
  {
    value: 5,
    label: 'banner'
  },
  {
    value: 6,
    label: '开屏'
  },

  {
    value: 7,
    label: '贴片'
  },
  {
    value: 8,
    label: '全屏视频'
  },
  {
    value: 9,
    label: '短视频内容'
  }
]

export const adAppOptions = [
  {
    value: 1,
    label: '安卓App'
  },
  {
    value: 2,
    label: 'IOS'
  }
]

export const adTriggerOptions = [
  {
    value: 1,
    label: '短剧列表页'
  },
  {
    value: 2,
    label: '播放页'
  },
  {
    value: 3,
    label: '开屏'
  },
  {
    value: 4,
    label: '列表头部banner'
  },
  {
    value: 5,
    label: '标签间隔'
  },
  {
    value: 6,
    label: '“我的”页面'
  },
  {
    value: 7,
    label: '二级分类'
  },
  {
    value: 8,
    label: '短剧推荐'
  },
  {
    value: 9,
    label: '剧集详情'
  },
  {
    value: 10,
    label: '剧集详情-会员'
  },
  {
    value: 11,
    label: '首页draw自渲染'
  },
  {
    value: 12,
    label: '详情页draw自渲染'
  },
  {
    value: 13,
    label: '星芽-安卓-feed吸底信息流'
  },
  {
    value: 14,
    label: '热启动开屏广告'
  },
  {
    value: 15,
    label: '视频滑滑流插屏广告'
  },
  {
    value: 16,
    label: '“我的”页自渲染信息流'
  },
  {
    value: 17,
    label: '星芽-安卓-feed吸底信息流-1020-广告样式优化实验'
  },
  {
    value: 18,
    label: '剧集详情页中插禁滑信息流'
  },
  {
    value: 19,
    label: '推荐页中插信息流'
  },
  {
    value: 20,
    label: '福利页激励视频'
  },
  {
    value: 21,
    label: '锁剧激励视频'
  },
  {
    value: 22,
    label: '福利弹窗激励视频'
  },
  {
    value: 23,
    label: '签到弹窗激励视频'
  },
  {
    value: 24,
    label: '福利看广告提现激励视频'
  },
  {
    value: 25,
    label: '免广告激励视频'
  },
  {
    value: 26,
    label: '逛街任务激励视频'
  }
]

export const adRewardTypeOptions = [
  {
    value: 1,
    label: '解锁剧集'
  },
  {
    value: 2,
    label: '奖励kb'
  }
]

export const adChanneleOptions = [
  {
    value: 1,
    label: '穿山甲'
  },
  {
    value: 2,
    label: 'TopOn'
  }
]

export const groupTagList = [
  {
    value: 'A',
    label: 'A组'
  },
  {
    value: 'B',
    label: 'B组'
  },
  {
    value: 'C',
    label: 'C组'
  },
  {
    value: 'D',
    label: 'D组'
  },
  {
    value: 'E',
    label: 'E组'
  },
  {
    value: 'F',
    label: 'F组'
  }
]

export const adStatusOptions = [
  {
    value: 1,
    label: '启用'
  },
  {
    value: 2,
    label: '禁止'
  }
]

export const classLevelOptions = [
  {
    value: 1,
    label: '一级'
  },
  {
    value: 2,
    label: '二级'
  }
]

export const classStatusOptions = [
  {
    value: 1,
    label: '展示'
  },
  {
    value: 2,
    label: '隐藏'
  }
]

export const tagSystemOptions = [
  {
    value: 1,
    label: '展示'
  },
  {
    value: 2,
    label: '隐藏'
  }
]

export const tagStyleOptions = [
  {
    value: 1,
    label: '横着滚动列表'
  },
  {
    value: 2,
    label: '竖着列表瀑布流可以分页'
  }
]

export const tagStatusOptions = [
  {
    value: 1,
    label: '展示'
  },
  {
    value: 2,
    label: '隐藏'
  }
]

export const theaterStatusOptions = [
  {
    value: 2,
    label: '未上架'
  },
  {
    value: 1,
    label: '已上架'
  }
]

export const theaterCopyOptions = [
  {
    value: 1,
    label: '无版权'
  },
  {
    value: 2,
    label: '有版权'
  }
]

export const theaterOverOptions = [
  {
    value: 1,
    label: '未完结'
  },
  {
    value: 2,
    label: '已完结'
  }
]

export const theaterSearchOptions = [
  {
    value: 2,
    label: '不允许搜索'
  },
  {
    value: 1,
    label: '允许搜索'
  }
]

// 短剧分享配置
export const theaterShareOptions = [
  {
    value: 0,
    label: '不允许分享'
  },
  {
    value: 1,
    label: '允许分享'
  }
]

export const theaterUnlockTypeOptions = [
  {
    value: 1,
    label: '广告'
  },
  {
    value: 2,
    label: 'kb'
  }
]

export const theaterThemeBgColorOptions = [
  {
    value: '#2C5994'
  },
  {
    value: '#8D6427'
  },
  {
    value: '#823333'
  },
  {
    value: '#A0445A'
  },
  {
    value: '#245D6F'
  },
  {
    value: '#564D8E'
  },
  {
    value: '#3C5937'
  },
  {
    value: '#272934'
  }
]

export const collectionBgColorOptions = [
  {
    value: '#27292C'
  },
  {
    value: '#4D3B3B'
  },
  {
    value: '#3C3C2E'
  },
  {
    value: '#3C4A3C'
  },
  {
    value: '#293A39'
  },
  {
    value: '#333343'
  },
  {
    value: '#3B2F3B'
  }
]

export const copy_typeOptions = [
  { label: '买断', value: 1 },
  { label: '纯分成', value: 2 },
  { label: '保底分成', value: 3 }
]

export const copy_overOptions = [
  { label: '版权期限内', value: 1, type: 'success' },
  { label: '版权已到期', value: 2, type: 'danger' },
  { label: '即将到期', value: 3, type: 'warning' }
]
export const carouselTypeOptions = [
  {
    value: 1,
    label: '视频'
  },
  {
    value: 2,
    label: '广告'
  }
]

export const promotionLinkKindOptions = [
  // {
  //   value: -1,
  //   label: "全部"
  // },
  // {
  //   value: 0,
  //   label: "自然量"
  // },
  {
    value: 1,
    label: '抖音'
  },
  {
    value: 2,
    label: '快手'
  },
  {
    value: 3,
    label: '腾讯'
  },
  {
    value: 4,
    label: '百度'
  },
  {
    value: 5,
    label: '小米'
  },
  {
    value: 6,
    label: 'vivo'
  },
  {
    value: 7,
    label: 'oppo'
  }
]
export const reportStategyOptions = [
  {
    value: 1,
    label: '巨量'
  },
  {
    value: 2,
    label: '快手'
  },
  {
    value: 3,
    label: '广点通'
  },
  {
    value: 4,
    label: '百度'
  },
  {
    value: 5,
    label: '小米'
  },
  {
    value: 6,
    label: 'vivo'
  },
  {
    value: 7,
    label: 'OPPO'
  },
  {
    value: 8,
    label: '荣耀'
  },
  {
    value: 9,
    label: '快手聚星'
  },
  {
    value: 10,
    label: '网易'
  },
  {
    value: 11,
    label: '爱奇艺麒麟'
  },
  {
    value: 12,
    label: '抖音星图'
  },
  {
    value: 13,
    label: '趣头条'
  },
  {
    value: 14,
    label: 'bilibili'
  },
  {
    value: 15,
    label: '苹果ASO'
  },
  {
    value: 16,
    label: '华为'
  },
  {
    value: 17,
    label: 'UC'
  }
]
export const reportStategySubOptions = [
  {
    value: 1,
    label: '抖音',
    pid: 1
  },
  {
    value: 2,
    label: '穿山甲',
    pid: 1
  },
  {
    value: 3,
    label: '通投智选',
    pid: 1
  },
  {
    value: 4,
    label: '站内',
    pid: 2
  },
  {
    value: 5,
    label: '联盟',
    pid: 2
  },
  {
    value: 6,
    label: 'XQXS',
    pid: 3
  },
  {
    value: 7,
    label: '优量汇',
    pid: 3
  },
  {
    value: 8,
    label: '朋友圈',
    pid: 3
  },
  {
    value: 9,
    label: '视频号',
    pid: 3
  },
  {
    value: 10,
    label: '通投',
    pid: 3
  },
  {
    value: 11,
    label: '百度sem',
    pid: 4
  },
  {
    value: 12,
    label: '站内',
    pid: 4
  },
  {
    value: 13,
    label: '联盟',
    pid: 4
  },
  {
    value: 14,
    label: '小米商店',
    pid: 5
  },
  {
    value: 15,
    label: '小米信息流',
    pid: 5
  },
  {
    value: 16,
    label: 'vivo商店',
    pid: 6
  },
  {
    value: 17,
    label: 'vivo信息流',
    pid: 6
  },
  {
    value: 18,
    label: 'OPPO商店',
    pid: 7
  },
  {
    value: 19,
    label: 'OPPO信息流',
    pid: 7
  },
  {
    value: 20,
    label: '荣耀商店',
    pid: 8
  },
  {
    value: 21,
    label: '荣耀信息流',
    pid: 8
  },
  // {
  //   value: 22,
  //   label: "抖音星图",
  //   pid: 14
  // },
  // {
  //   value: 23,
  //   label: "快手达人",
  //   pid: 9
  // },
  {
    value: 24,
    label: '公众号',
    pid: 3
  },
  {
    value: 25,
    label: '激励浏览',
    pid: 3
  },
  {
    value: 26,
    label: '网易',
    pid: 10
  },
  {
    value: 27,
    label: '智选',
    pid: 11
  },
  {
    value: 28,
    label: '合作媒体',
    pid: 11
  },
  {
    value: 29,
    label: '星广联投',
    pid: 12
  },
  {
    value: 30,
    label: '投稿任务',
    pid: 12
  },
  {
    value: 31,
    label: '指派任务',
    pid: 12
  },
  {
    value: 32,
    label: '信息流',
    pid: 13
  },
  {
    value: 33,
    label: '星视频',
    pid: 9
  },
  {
    value: 34,
    label: '星直播',
    pid: 9
  },
  {
    value: 35,
    label: '星任务-视频',
    pid: 9
  },
  {
    value: 36,
    label: '星任务-直播',
    pid: 9
  },
  {
    value: 37,
    label: '信息流',
    pid: 14
  },
  {
    value: 38,
    label: '欧爱',
    pid: 15
  },
  {
    value: 39,
    label: '爱盈利',
    pid: 15
  },
  {
    value: 40,
    label: '伏尔基河',
    pid: 15
  },
  {
    value: 41,
    label: '信息流',
    pid: 16
  },
  {
    value: 42,
    label: '应用商店',
    pid: 16
  },
  {
    value: 43,
    label: '信息流',
    pid: 17
  }
]
export const biChannelOptions = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 0,
    label: '自然量'
  },
  {
    value: 1,
    label: '抖音'
  },
  {
    value: 2,
    label: '快手'
  },
  {
    value: 3,
    label: '腾讯'
  },
  {
    value: 4,
    label: '百度'
  },
  {
    value: 5,
    label: '小米'
  }
]

export const promotionLinkKindOptionsOnlyDy = [
  {
    value: 1,
    label: '抖音'
  }
]

export const reportKindOptions = [
  {
    value: 1,
    label: '抖音'
  },
  {
    value: 2,
    label: '快手'
  },
  {
    value: 3,
    label: '腾讯'
  },
  {
    value: 4,
    label: '百度'
  },
  {
    value: 5,
    label: '小米'
  },
  {
    value: 6,
    label: 'vivo'
  },
  {
    value: 7,
    label: 'oppo'
  }
]

export const reportTypeOptions = [
  {
    value: 1,
    label: '自然日'
  }
  // {
  //   value: 2,
  //   label: "24小时"
  // }
]

export const classTypeOptions = [
  {
    value: 1,
    label: '登陆/注册'
  },
  {
    value: 2,
    label: '剧集数'
  },
  {
    value: 3,
    label: '广告'
  },
  {
    value: 4,
    label: '看剧时长'
  }
]

// 投放链接管理-编辑回传管理-关键行为
export const reportGameAddictionOptions = [
  {
    value: 1,
    label: '广告'
  },
  {
    value: 2,
    label: '看剧时长'
  }
]

export const adRuleTypeOptions = [
  {
    value: 1,
    label: '曝光'
  },
  {
    value: 2,
    label: '看完'
  }
]

export const reportRepeatOptions = [
  {
    value: 1,
    label: '是'
  },
  {
    value: 2,
    label: '不是'
  }
]

export const postBackOptions = [
  {
    value: true,
    label: '是'
  },
  {
    value: false,
    label: '不是'
  }
]

export const pushStatusOptions = [
  {
    value: -1,
    label: '禁用'
  },
  {
    value: 1,
    label: '启用'
  }
]

export const pushEventTypeOptions = [
  {
    value: 'WATCH-TV-PLAY',
    label: '看剧'
  },
  {
    value: 'GO-H5',
    label: '跳转h5'
  },
  {
    value: 'GO-Center',
    label: '个人中心'
  }
]

export const pushTypeOptions = [
  {
    value: 1,
    label: '根据时间推送'
  },
  {
    value: 2,
    label: '根据用户推送'
  },
  {
    value: 3,
    label: '全部用户推送'
  }
]

export const taskStatusOptions = [
  {
    value: 0,
    label: '排队中'
  },
  {
    value: 1,
    label: '发送中'
  },
  {
    value: 2,
    label: '发送完成'
  },
  {
    value: 3,
    label: '发送失败'
  },
  {
    value: 4,
    label: '消息被撤销'
  },
  {
    value: 5,
    label: '消息过期'
  },
  {
    value: 6,
    label: '筛选结果为空'
  },
  {
    value: 7,
    label: '定时任务尚未开始处理'
  }
]

export const adSceneOptions = [
  {
    value: 1,
    label: '广告投放'
  },
  {
    value: 2,
    label: '桌面图标'
  },
  {
    value: 3,
    label: '消息推送'
  }
]

export const publishStatusOptions = [
  {
    value: 1,
    label: '待发布'
  },
  {
    value: 2,
    label: '发布'
  },
  {
    value: 3,
    label: '关闭'
  }
]

export const publishForceOptions = [
  {
    value: 0,
    label: '非强制更新'
  },
  {
    value: 1,
    label: '强制更新'
  }
]

export const publishFullOptions = [
  {
    value: 0,
    label: '全量更新'
  },
  {
    value: 1,
    label: '部分更新'
  }
]

export const publishOsOptions = [
  {
    value: 1,
    label: '安卓'
  },
  {
    value: 2,
    label: '苹果'
  }
]

export const publishNoticeModeOptions = [
  {
    value: 1,
    label: '间隔天数'
  },
  {
    value: 2,
    label: '每次启动'
  }
]

export const goodsTypeOptions = [
  {
    value: -1,
    label: '一级分类'
  },
  {
    value: 1,
    label: '二级分类-VIP充值'
  },
  {
    value: 2,
    label: '二级分类-看币类型'
  }
]

export const kbTypeOptions = [
  {
    value: 1,
    label: '永久KB'
  },
  {
    value: 2,
    label: '赠送KB'
  }
]

export const orderStatusOptions = [
  {
    value: 'PAYING',
    label: '待支付'
  },
  {
    value: 'TRADE_SUCCESS',
    label: '支付成功'
  },
  {
    value: 'TRADE_CLOSED',
    label: '超时关闭'
  },
  {
    value: 'WAIT_BUYER_PAY',
    label: '交易创建'
  },
  {
    value: 'TRADE_FINISHED',
    label: '交易结束'
  }
]

export const feedbackStatusOptions = [
  {
    value: 1,
    label: '未处理'
  },
  {
    value: 2,
    label: '已超时'
  },
  {
    value: 3,
    label: '处理中'
  },
  {
    value: 4,
    label: '处理完成'
  }
]

export const feedbackPriorityOptions = [
  {
    value: 0,
    label: '普通'
  },
  {
    value: 1,
    label: '重要'
  }
]

export const feedbackSortOptions = [
  {
    value: 0,
    label: '按反馈时间排序'
  },
  {
    value: 1,
    label: '按剩余时间排序'
  }
]

export const selectDimensionality = [
  {
    value: 'all',
    label: '全部'
  },
  {
    value: 'key',
    label: '关键行为'
  },
  {
    value: 'android',
    label: '安卓'
  },
  {
    value: 'ios',
    label: 'IOS'
  }
  // {
  //   value: "tmp",
  //   label: "临时"
  // }
]

export const ecpmTypeOptions = [
  { value: '1', label: 'ecpm底价' },
  { value: '2', label: 'ecpm_avg底价' }
]

export const klTypeOptions = [
  { value: '1', label: '概率扣量' },
  // { value: "2", label: "笔数扣量" },
  { value: '3', label: '百分比扣量' }
]

export const simpleOptions = [
  { label: '是', value: true },
  { label: '否', value: false }
]

export const payTypeOptions = [
  { value: 'wechat', label: 'wechat' },
  { value: 'alipay', label: 'alipay' },
  { value: 'apple', label: 'apple' }
]
export const isShareOptions = [
  {
    value: 0,
    label: '未分享'
  },
  {
    value: 1,
    label: '已分享'
  }
]
export const stayTypeOptions = [
  { value: 'next_day_open', label: '次留' },
  { value: 'retention_2d', label: '2日留' },
  { value: 'retention_3d', label: '3日留' },
  { value: 'retention_4d', label: '4日留' },
  { value: 'retention_5d', label: '5日留' },
  { value: 'retention_6d', label: '6日留' },
  { value: 'retention_7d', label: '7日留' }
]
export const keepDataTypeOptions = [
  { value: 'vip_num', label: '会员数' },
  { value: 'total_roi', label: '总ROI' },
  { value: 'ad_type3_roi', label: '激励广告ROI' },
  { value: 'recharge_roi', label: '充值ROI' },
  { value: 'ad_total_avg', label: '平均总广告次数' },
  { value: 'ad_type3_avg', label: '平均总激励广告次数' },
  { value: 'ad_type3_ecpm_avg', label: '平均总激励广告ECPM' },
  { value: 'theater_total_pv', label: '总播放次数' },
  { value: 'theater_total_uv', label: '总播放人数' },
  { value: 'theater_play_avg', label: '剧平均播放次数' },
  { value: 'theater_complete_avg', label: '剧平均播放完成次数' },
  { value: 'theater_complete_rate', label: '播放完成率' },
  { value: 'theater_num_avg', label: '剧平均播放剧集数' }
]
export const userDimensionOptions = [
  { value: 1, label: 'DID' },
  { value: 2, label: 'UID' }
]

export const theaterThemeTitleOptions = [
  { value: 0, label: '无限定' },
  { value: 1, label: '看了5分钟的用户' },
  { value: 2, label: '直接跳出的用户' }
]

// 商品状态
export const goodsStatusOptions = [
  {
    value: 2,
    label: '上架'
  },
  {
    value: 1,
    label: '下架'
  }
]

// 商品所属端
export const goodsPlatformOptions = [
  {
    value: 'android',
    label: '安卓'
  },
  {
    value: 'ios',
    label: 'IOS'
  }
]

// 商品标签
export const goodsTagOptions = [
  {
    value: 'NEW_YEAR_SPECIAL',
    label: '新春特惠'
  },
  {
    value: 'GREAT_VALUE_OFFER',
    label: '超值特惠'
  },
  {
    value: 'LIMITED_TIME_EXPERIENCE',
    label: '限时体验'
  },
  {
    value: 'LIMITED_TIME_HALF_PRICE',
    label: '限时五折'
  },
  {
    value: 'FIRST_DISCOUNT',
    label: '首开特惠'
  },

  { value: 'BOGO', label: '买一赠一' },
  { value: 'LIMITED_TIME_10_PCT_OFF_PRICE', label: '限时1折' },
  { value: 'LIMITED_TIME_20_PCT_OFF_PRICE', label: '限时2折' },
  { value: 'LIMITED_TIME_30_PCT_OFF_PRICE', label: '限时3折' },
  { value: 'LIMITED_TIME_40_PCT_OFF_PRICE', label: '限时4折' },

  { value: 'LIMITED_TIME_60_PCT_OFF_PRICE', label: '限时6折' },
  { value: 'LIMITED_TIME_70_PCT_OFF_PRICE', label: '限时7折' },
  { value: 'LIMITED_TIME_80_PCT_OFF_PRICE', label: '限时8折' },
  { value: 'LIMITED_TIME_90_PCT_OFF_PRICE', label: '限时9折' },
  { value: 'NEW_YEAR_DISCOUNT_VIP_COIN', label: '新春特惠-看币' },
  { value: 'GREAT_DISCOUNT_VIP_COIN', label: '超值特惠-看币' },
  { value: 'FIRST_BUY_DISCOUNT_VIP_COIN', label: '首购特惠-看币' },
  { value: 'LIMITED_TIME_0_VIP_COIN', label: '限时特惠-看币' },
  { value: 'LIMITED_TIME_50_VIP_COIN', label: '限时5折-看币' },
  { value: 'LIMITED_TIME_60_VIP_COIN', label: '限时6折-看币' },
  { value: 'LIMITED_TIME_70_VIP_COIN', label: '限时7折-看币' },
  { value: 'LIMITED_TIME_80_VIP_COIN', label: '限时8折-看币' },
  { value: 'LIMITED_TIME_90_VIP_COIN', label: '限时9折-看币' }
]

// 商品选中标签
export const goodSelectedTagOptions = [
  {
    value: 'NEW_YEAR_SPECIAL',
    label: '新春特惠'
  },
  {
    value: 'EXCLUSIVE_WEEKLY_CARD',
    label: '尊享周卡'
  },
  {
    value: 'EXCLUSIVE_MONTHLY_CARD',
    label: '尊享月卡'
  },
  {
    value: 'EXCLUSIVE_ANNUAL_CARD',
    label: '尊享年卡'
  },
  {
    value: 'GREAT_VALUE_OFFER',
    label: '超值特惠'
  },
  {
    value: 'LIMITED_TIME_EXPERIENCE',
    label: '限时体验'
  },
  {
    value: 'LIMITED_TIME_HALF_PRICE',
    label: '限时五折'
  },
  {
    value: 'FIRST_DISCOUNT',
    label: '首开特惠'
  },
  { value: 'BOGO', label: '买一赠一' },
  { value: 'LIMITED_TIME_10_PCT_OFF_PRICE', label: '限时1折' },
  { value: 'LIMITED_TIME_20_PCT_OFF_PRICE', label: '限时2折' },
  { value: 'LIMITED_TIME_30_PCT_OFF_PRICE', label: '限时3折' },
  { value: 'LIMITED_TIME_40_PCT_OFF_PRICE', label: '限时4折' },
  { value: 'LIMITED_TIME_60_PCT_OFF_PRICE', label: '限时6折' },
  { value: 'LIMITED_TIME_70_PCT_OFF_PRICE', label: '限时7折' },
  { value: 'LIMITED_TIME_80_PCT_OFF_PRICE', label: '限时8折' },
  { value: 'LIMITED_TIME_90_PCT_OFF_PRICE', label: '限时9折' },
  { value: 'NEW_YEAR_DISCOUNT_VIP_COIN', label: '新春特惠-看币' },
  { value: 'GREAT_DISCOUNT_VIP_COIN', label: '超值特惠-看币' },
  { value: 'FIRST_BUY_DISCOUNT_VIP_COIN', label: '首购特惠-看币' },
  { value: 'LIMITED_TIME_0_VIP_COIN', label: '限时特惠-看币' },
  { value: 'LIMITED_TIME_50_VIP_COIN', label: '限时5折-看币' },
  { value: 'LIMITED_TIME_60_VIP_COIN', label: '限时6折-看币' },
  { value: 'LIMITED_TIME_70_VIP_COIN', label: '限时7折-看币' },
  { value: 'LIMITED_TIME_80_VIP_COIN', label: '限时8折-看币' },
  { value: 'LIMITED_TIME_90_VIP_COIN', label: '限时9折-看币' },
  { value: 'SUBS_WEEK', label: '连续包周' },
  { value: 'SUBS_MONTH', label: '连续包月' },
  { value: 'SUBS_YEAR', label: '连续包季' },
  { value: 'SUPREME_YEAR', label: '尊享年卡' },
  { value: 'MEMBER_1_DAY_FREE_WATCH', label: '1天会员免费看' },
  { value: 'MEMBER_3_DAY_FREE_WATCH', label: '3天会员免费看' },
  { value: 'MEMBER_7_DAY_FREE_WATCH', label: '7天会员免费看' },
  { value: 'MEMBER_15_DAY_FREE_WATCH', label: '15天会员免费看' },
  { value: 'MEMBER_QUARTER_FREE_WATCH', label: '尊享季卡会员' }
]

export const goodsTypesOptions = [
  {
    value: 0,
    label: '普通商品'
  },
  {
    value: 1,
    label: '抽奖打折'
  },
  {
    value: 2,
    label: '赠送商品'
  },
  {
    value: 3,
    label: '挽留商品'
  },
  {
    value: 4,
    label: '限时打折'
  },
  {
    value: 5,
    label: 'push挽留'
  },
  {
    value: 6,
    label: '终点挽留'
  },
  {
    value: 13,
    label: '续费优惠挽留'
  },
  {
    value: 14,
    label: '活动类型'
  }
]

/**
 *  banner位
 */

export const bannerPostionOptions = [
  {
    label: '剧场页',
    value: 1
  },
  {
    label: '个人中心',
    value: 2
  }
]

export const bannerStateOption = [
  {
    value: 1,
    label: '上架'
  },
  {
    value: 2,
    label: '下架'
  }
]

export const jumpConfigOptions = [
  {
    value: 1,
    label: '应用内短剧播放页'
  },
  {
    value: 2,
    label: 'H5活动页'
  },
  {
    value: 3,
    label: '推荐Tab'
  },
  {
    value: 4,
    label: '剧场Tab'
  },
  {
    value: 5,
    label: '福利Tab'
  },
  {
    value: 6,
    label: '我的Tab	'
  }
]

export const bannerTypeOptions = [
  {
    value: 1,
    label: '图片'
  }
  // {
  //     value: 2,
  //     label: "广告"
  // },
]

/**
 *  主题推荐位
 */

export const themeStateOption = [
  {
    value: 1,
    label: '上架'
  },
  {
    value: 2,
    label: '下架'
  }
]

/**
 * 热搜词
 */

export const hotSearchWordsOption = [
  {
    value: 1,
    label: '上架'
  },
  {
    value: 2,
    label: '下架'
  }
]

export const hotSearchWordsColorOptions = [
  {
    value: '#FF5C4F'
  }
]

export const applicationPlatformdOptions = [
  {
    value: 'ios',
    label: 'iOS'
  },
  {
    value: 'android',
    label: '安卓'
  }
]

export const qualityLevelOptions = [
  // ：S、A、B、C、D
  {
    value: 'S',
    label: 'S'
  },
  {
    value: 'A',
    label: 'A'
  },
  {
    value: 'B',
    label: 'B'
  },
  {
    value: 'C',
    label: 'C'
  },
  {
    value: 'D',
    label: 'D'
  }
]

export const riskLevelOptions = [
  {
    value: 1,
    label: '1'
  },

  {
    value: 2,
    label: '2'
  },
  {
    value: 3,
    label: '3'
  },
  {
    value: 4,
    label: '4'
  },

  {
    value: 5,
    label: '5'
  },
  {
    value: 6,
    label: '6'
  },
  {
    value: 7,
    label: '7'
  },
  {
    value: 8,
    label: '8'
  },
  {
    value: 9,
    label: '9'
  }
]

export const availableUserOptions = [
  {
    value: 0,
    label: '全部'
  },

  {
    value: 1,
    label: '无购买记录用户'
  }
]

export const durationOptions = [
  {
    value: 7,
    label: '7天'
  },
  {
    value: 31,
    label: '31天'
  },
  {
    value: 93,
    label: '93天'
  },
  {
    value: 365,
    label: '365天'
  }
]
export const pushosOptions = [
  { value: 0, label: '全部' },
  { value: 1, label: '安卓' },
  { value: 2, label: 'iOS' }
]

export const repositoriesOsOptions = [
  {
    value: 1,
    label: '安卓'
  },
  {
    value: 2,
    label: 'IOS'
  }
]

export const topOperateStateOption = [
  { label: '上架', value: 1 },
  { label: '下架', value: 2 }
]

export const volc_audit_statusOptions = [
  { label: 'REVIEW', value: 1 }
  //   { label: "PASS", value: 2 },
  //   { label: "BLOCK", value: 3 }
]

export const AuditstatusOptions = [
  { label: '待审核', value: 1 },
  { label: '审核通过', value: 2 },
  { label: '审核未通过', value: 3 }
]

export const applicablePeopleOption = [
  { label: '全部用户', value: 1 },
  { label: 'VIP用户', value: 2 },
  { label: '非VIP用户', value: 3 }
]

export const classOption = [
  { label: '日更剧场', value: 1 },
  { label: '热播剧', value: 2 },
  { label: '右上角运营位', value: 3 },
  { label: '悬浮运营位', value: 4 },
  { label: '会员专享-今日星选', value: 5 },
  { label: '过期会员', value: 6 },
  { label: '看币-活动页', value: 7 }
]

export const business_typeOption = [
  { label: '内容', value: 1 },
  { label: '会员', value: 2 },
  { label: '福利', value: 3 }
]

export const linkToOption = [
  { label: '应用内短剧播放页', value: 8 },
  { label: 'H5活动页', value: 2 },
  { label: '会员详情页', value: 7 },
  { label: '排行榜', value: 10 },
  { label: '福利页', value: 5 }
]

// 风险标签管理 是否启用

export const riskIsUseOptions = [
  { label: '是', value: 1 },
  { label: '否', value: 2 }
]

// 风险程度
export const riskExtentOptions = [
  {
    label: '低风险',
    value: 1,
    enum: [1, 2, 3],
    type: 'success'
  },
  {
    label: '中风险',
    value: 2,
    enum: [4, 5, 6],
    type: 'warning'
  },
  {
    label: '高风险',
    value: 3,
    enum: [7, 8, 9],
    type: 'danger'
  }
]

// 付费模板
export const payTemplate = [
  { label: '免费模板C', value: 12 },
  { label: '免费模板D', value: 13 },
  { label: '免费模板E', value: 14 },
  { label: '免费模板F', value: 15 },
  { label: '免费模板G', value: 16 },
  { label: '免费模板H', value: 17 },
  { label: '免费模板I', value: 18 },
  { label: '免费模板J', value: 19 },
  { label: '免费模板K', value: 20 },
  { label: '免费模板L', value: 21 },
  { label: '免费模板M', value: 22 },
  { label: '免费模板N', value: 23 },
  { label: '免费模板O', value: 24 },
  { label: '免费模板P', value: 25 },
  { label: '免费模板Q', value: 26 },
  { label: '免费模板R', value: 27 },
  { label: '免费模板S', value: 28 },
  { label: '免费模板T', value: 29 },
  { label: '免费模板U', value: 30 },
  { label: '免费模板V', value: 31 },
  { label: '免费模板W', value: 32 },
  { label: '免费模板X', value: 33 },
  { label: '免费模板Y', value: 34 },
  { label: '免费模板Z', value: 35 },
  { label: '免费模板AA', value: 36 },
  { label: '免费模板AB', value: 37 },
  { label: '免费模板AC', value: 38 },
  { label: '免费模板AD', value: 39 },
  { label: '免费模板AE', value: 40 },
  { label: '免费模板AF', value: 41 },
  { label: '免费模板AG', value: 42 },
  { label: '免费模板AH', value: 43 },
  { label: '免费模板AI', value: 44 },
  { label: '免费模板AJ', value: 45 },
  { label: '免费模板AK', value: 46 },
  { label: '免费模板AL', value: 47 },
  { label: '免费模板AM', value: 48 },
  { label: '免费模板AN', value: 49 },
  { label: '免费模板AO', value: 50 },
  { label: '免费模板AP', value: 51 },
  { label: '免费模板AQ', value: 52 },
  { label: '免费模板AR', value: 53 },
  { label: '免费模板AS', value: 54 },
  { label: '免费模板AT', value: 55 },
  { label: '免费模板AU', value: 56 },
  { label: '免费模板AV', value: 57 },
  { label: '免费模板AW', value: 58 },
  { label: '免费模板AX', value: 59 },
  { label: '免费模板AY', value: 60 }
]
